"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.separatorStyle = exports.titleStyle = exports.titleContainerStyle = exports.iconStyle = exports.rootStyle = void 0;

var _reactEmotion = require("react-emotion");

var rootStyle = function rootStyle(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("bottom:0;left:0;width:100%;position:fixed;background-color:", theme.color.dark.saturn, ";color:", theme.color.dark.white, ";z-index:5;")
  );
};

exports.rootStyle = rootStyle;

var iconStyle = function iconStyle(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("width:16px;height:16px;margin-right:8px;fill:", theme.color.dark.white, ";")
  );
};

exports.iconStyle = iconStyle;
var titleContainerStyle =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;align-items:center;padding:22px 20px;");
exports.titleContainerStyle = titleContainerStyle;
var titleStyle =
/*#__PURE__*/
(0, _reactEmotion.css)("font-size:12px;font-weight:500;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;text-transform:uppercase;");
exports.titleStyle = titleStyle;

var separatorStyle = function separatorStyle(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("height:1px;width:100%;background-color:", theme.color.dark.mars, ";")
  );
};

exports.separatorStyle = separatorStyle;